import type { ReactNode } from 'react';
import { chipCls } from './styles';

interface Props {
  active: boolean;
  onClick: () => void;
  /** Optional leading icon (e.g. <Archive className="h-4 w-4" />). */
  icon?: ReactNode;
  children: ReactNode;
  title?: string;
  /** Dim + block interaction (and announce as disabled to assistive tech). */
  disabled?: boolean;
}

/**
 * Toggle / quick-filter chip. One canonical active scheme (outline-primary),
 * replacing the outline-vs-filled, three-sizes drift across modules.
 */
export default function FilterChip({ active, onClick, icon, children, title, disabled }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={active}
      title={title}
      className={`${chipCls(active)} disabled:cursor-not-allowed disabled:opacity-50`}
    >
      {icon}
      {children}
    </button>
  );
}
